// extracted by mini-css-extract-plugin
export default {"btn":"ReservationRow_btn__y7Y2f","table-number-cell":"ReservationRow_table-number-cell__FvDK8","flagged":"ReservationRow_flagged__mmVJL","tr":"ReservationRow_tr__dfgVq"};